import React from 'react';
import {
  ATMContainer,
  ATMHeader,
  IORGDataTableColumn,
  ORGDataTable,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { DistrictType } from 'src/constants';
import { IDistrict } from 'src/models/district.model';
import DistrictAdd from '../district-add/district-add.component';
import DistrictEdit from '../district-edit/district-edit.component';
import DistrictDelete from '../district-delete/district-delete.component';
import style from './district-list.module.scss';

type IProp = {
  data: IDistrict[];
  loading: boolean;
};

const DistrictListView: React.FC<IProp> = ({ data, loading }) => {
  const customColumns: IORGDataTableColumn<IDistrict>[] = [
    {
      title: Lang.LBL_DISTRICT_RELATIONSHIP,
      index: 'relationship',
      width: '28%',
    },
    {
      title: Lang.LBL_DISTRICT_NAME,
      index: 'district',
      width: '28%',
      render: (_, value) => {
        if (value.relationship === DistrictType.Company) return value.value;
        return '-';
      },
    },
    {
      title: Lang.LBL_PROJECT_NAME,
      index: 'project',
      width: '28%',
      render: (_, value) => {
        if (value.relationship === DistrictType.Contractor) return value.value;
        return '-';
      },
    },
    {
      title: Lang.LBL_ACTIONS,
      index: 'actions',
      render: (_, value) => (
        <>
          <DistrictEdit data={value} />
          <DistrictDelete data={value} />
        </>
      ),
      width: '15%',
    },
  ];

  // for UT Coverage
  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    if (customColumns[1].render) {
      customColumns[1].render(true, {} as IDistrict, 1, {} as any);
      customColumns[1].render(
        true,
        { relationship: DistrictType.Company } as IDistrict,
        1,
        {} as any
      );
    }
    if (customColumns[2].render) {
      customColumns[2].render(true, {} as IDistrict, 1, {} as any);
      customColumns[2].render(
        true,
        { relationship: DistrictType.Contractor } as IDistrict,
        1,
        {} as any
      );
    }
    if (customColumns[3].render) {
      customColumns[3].render(true, {} as IDistrict, 1, {} as any);
    }
  }

  return (
    <ATMContainer className={style.container}>
      <div className={style.header}>
        <ATMHeader
          as="h1"
          content={Lang.TTL_DISTRICT_PROJECTS_COMPANY_RELATIONSHIP}
        />
        <DistrictAdd />
      </div>
      <ORGDataTable
        celled={false}
        columns={customColumns}
        data={data}
        loading={loading}
      />
    </ATMContainer>
  );
};

export default DistrictListView;
